import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Trash = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Trash' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M4,5 L20,5 L20,23 L4,23 L4,5 Z M1,5 L23,5 M9,1 L15,1 L15,5 L9,5 L9,1 Z M9,1 L15,1 L15,5 L9,5 L9,1 Z M15,9 L15,19 M9,9 L9,19' />
  </StyledIcon>
);
